import { nanoid } from '@reduxjs/toolkit';

const id = nanoid();

export default function Wind({ color = '#000000', ...props }: Record<string, unknown> & { color?: string }) {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>wind</title>
      <defs>
        <path
          d="M9.29919854,2.29506367 C9.61891526,1.97344693 10.1150315,1.90723891 10.5078986,2.13375945 C10.9007657,2.36027999 11.0920185,2.8228134 10.9738525,3.26064088 C10.8556865,3.69846836 10.4576878,4.00196768 10.0041985,4.00006367 L1,4.00005485 C0.44771525,4.00005485 0,4.4477701 0,5.00005485 C0,5.5523396 0.44771525,6.00008149 1,6.00008149 L10,6.00008149 C11.3562691,6.00575807 12.5502652,5.09526012 12.9047633,3.78177768 C13.2592613,2.46829524 12.6855028,1.080695 11.5069015,0.401133386 C10.3283003,-0.278428233 8.83995162,-0.0798041689 7.88080146,0.885046037 C7.49143584,1.27672558 7.49331165,1.90988778 7.88499119,2.29925339 C8.27667073,2.68861901 8.90983293,2.6867432 9.29919854,2.29506367 Z M10.8808015,17.1150637 C11.8399516,18.0799139 13.3283003,18.2785379 14.5069015,17.5989763 C15.6855028,16.9194147 16.2592613,15.5318145 15.9047633,14.218332 C15.5502652,12.9048496 14.3562691,11.9943516 12.9958015,12.0000369 L1,12.0000369 C0.44771525,12.0000369 0,12.4477701 0,13.0000549 C0,13.5523396 0.44771525,14.0000549 1,14.0000549 L13,14.0000549 C13.4576878,13.998142 13.8556865,14.3016413 13.9738525,14.7394688 C14.0920185,15.1772963 13.9007657,15.6398297 13.5078986,15.8663503 C13.1150315,16.0928708 12.6189153,16.0266628 12.2991985,15.705046 C11.9098329,15.3133665 11.2766707,15.3114907 10.8849912,15.7008563 C10.4933116,16.0902219 10.4914358,16.7233841 10.8808015,17.1150637 Z M17.4362108,5.43805645 C17.9164771,4.95900494 18.6584728,4.86189075 19.2458489,5.20120663 C19.8332251,5.54052251 20.119777,6.23180879 19.9447146,6.88717066 C19.7696521,7.54253252 19.1765504,7.99884278 18.4982108,8.00005645 L1,8.00005485 C0.44771525,8.00005485 0,8.4477701 0,9.00005485 C0,9.5523396 0.44771525,10.0000549 1,10.0000549 L18.5,10.0000549 C20.0845815,9.99722136 21.4684856,8.93249741 21.8769646,7.40331973 C22.2854436,5.87414205 21.6168225,4.26114071 20.2462781,3.46940366 C18.8757337,2.67766661 17.1444105,2.90426639 16.0237892,4.02205325 C15.6327707,4.41208272 15.6319689,5.04524719 16.0219984,5.43626568 C16.4120279,5.82728417 17.0451923,5.82808592 17.4362108,5.43805645 Z"
          id={id}
        />
      </defs>
      <g id="🕹-Icons" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="Feather" transform="translate(-768, -142)">
          <g id="wind" transform="translate(769, 145)">
            <mask id={`mask-${id}`} fill="white">
              <use xlinkHref={`#${id}`} />
            </mask>
            <use id="Shape" fill={color} fillRule="nonzero" xlinkHref={`#${id}`} />
            <g id="COLOR/-black" mask={`url(#mask-${id})`} fill={color}>
              <g transform="translate(-1, -3)" id="Rectangle">
                <rect x={0} y={0} width={24} height={24} />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
